// extracted by mini-css-extract-plugin
module.exports = {"root":"footer-social_root__Gqwu8"};